import React from "react";

import {cn} from "@isudio/utils";
import type {IAssetSort} from "@isudio/data";
import {Button, Dropdowns, SearchInput, Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger} from "../../";
import {SheetClose} from "../../";

interface HeaderTitleNavProps {
  className?: string;
  searchRef?: React.RefObject<HTMLInputElement>;
  onSortChange?: (sort: IAssetSort) => void;
  onFilterChange?: (payload: any) => void;
  selectedAssetType?: string | null;
  selectedSearchBy?: string | null;
  onSearchChange?: (search: string) => void;
}

const HeaderRightNav = React.forwardRef<Element, HeaderTitleNavProps>(
  ({
     className = "header-right-nav",
     searchRef,
     onSortChange,
     onFilterChange,
     selectedAssetType,
     selectedSearchBy,
     onSearchChange
   }
  ) => {
    return (
      <nav
        className={cn(`${className}`, "flex")}>
        <div className="hidden lg:flex gap-2">
          <Dropdowns
            onSortChange={onSortChange}
            onFilterChange={onFilterChange}
            selectedAssetType={selectedAssetType}
          />

          <SearchInput
            searchRef={searchRef}
            selectedSearchBy={selectedSearchBy}
            onFilterChange={onFilterChange}
            onSearchChange={onSearchChange}
          />
        </div>

        <div className="lg:hidden">
          <Sheet>
            <SheetTrigger asChild>
              <Button
                variant="vanilla"
                tabIndex={-1}
                className={cn(className, "cursor-pointer")}
              >
                <i
                  className={`fa-duotone fa-light fa-sliders text-2xl`}/>
              </Button>
            </SheetTrigger>

            <SheetContent
              className="sort-filter-sheet flex flex-col gap-6 bg-bluegray-darker/85 border-none!"

            >
              <SheetHeader className="flex flex-row gap-2 items-center">
                <SheetClose className="flex w-fit h-fit">
                  <i className={`fa-duotone fa-light fa-left-from-line text-md md:text-xl xl:text-2xl text-bluegray-lighter cursor-pointer`}/>
                </SheetClose>
                <SheetTitle className="text-sm md:text-md xl:text-lg text-white font-bold tracking-wider">Sort, Filter & Search</SheetTitle>
              </SheetHeader>

              <div className="flex flex-col gap-4">
                <Dropdowns
                  onSortChange={onSortChange}
                  onFilterChange={onFilterChange}
                  selectedAssetType={selectedAssetType}
                />

                <SearchInput
                  className="w-full"
                  searchRef={searchRef}
                  selectedSearchBy={selectedSearchBy}
                  onFilterChange={onFilterChange}
                  onSearchChange={onSearchChange}
                />
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </nav>
    )
  }
);

HeaderRightNav.displayName = "HeaderRightNav"
export {HeaderRightNav}